import { features } from '@/mocks/homeData';

const bgClasses: Record<number, string> = {
  0: 'bg-primary-100',
  1: 'bg-accent-100',
  2: 'bg-secondary-100',
};

const iconClasses: Record<number, string> = {
  0: 'text-primary-500',
  1: 'text-accent-500',
  2: 'text-secondary-500',
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-16">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-100 rounded-full mb-3">选择理由</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台优势</h2>
          <p className="mt-2 text-foreground-600 text-sm">为什么选择黑料网站获取最新资讯</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-8 text-center hover:border-primary-200 transition-all duration-200 group"
            >
              <div className={`w-16 h-16 mx-auto flex items-center justify-center rounded-2xl ${bgClasses[idx]}`}>
                <i className={`${item.icon} text-2xl ${iconClasses[idx]}`}></i>
              </div>
              <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-900">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}